(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["td-product-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-product-reviews')) {
    class TdProductReviews extends HTMLElement {
      connectedCallback() {
        const link = this.querySelector('[data-td-reviews-link]');
        if (!link) return;
        this._handleClick = this._handleClick.bind(this);
        link.addEventListener('click', this._handleClick);
      }

      disconnectedCallback() {
        const link = this.querySelector('[data-td-reviews-link]');
        if (link) link.removeEventListener('click', this._handleClick);
      }

      _handleClick(e) {
        const targetId = this.dataset.tdScrollTarget;
        if (!targetId) return;
        const target = document.getElementById(targetId);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    }
    customElements.define('td-product-reviews', TdProductReviews);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["td-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-search-component')) {
  class TDSearchComponentFactory {
    static FILTER_MODE = 'product_type';

    static SELECTORS = Object.freeze({
      searchFilter: '[data-td-search-filter]',
      searchOverlay: '[data-td-search-overlay]',
    });

    static register() {
      if (customElements.get('td-search-component')) return;

      const BasePredictiveSearchComponent = customElements.get('predictive-search-component');
      if (!BasePredictiveSearchComponent) return;

      class TDSearchComponent extends BasePredictiveSearchComponent {
        constructor() {
          super();
          this.tdSearchController = null;
          this.tdSearchOverlay = null;
          this.tdActiveSearchRequest = null;
          this.tdSearchDebounceTimer = null;
          /** @type {MutationObserver | null} */
          this.tdResultsObserver = null;
        }

        connectedCallback() {
          super.connectedCallback();

          this.tdSearchController = new AbortController();
          const { signal } = this.tdSearchController;
          this.dataset.tdSearchContext = this.closest('.td-site-header') ? 'header' : 'default';

          this.syncSearchFilterFromInputValue();
          this.searchFilter?.addEventListener('change', this.handleSearchFilterChange, { signal });

          if (this.refs.form instanceof HTMLFormElement) {
            this.refs.form.addEventListener('submit', this.handleFilteredSubmit, { signal });
          }

          if (!this.dialog) {
            this.tdSearchOverlay = this.querySelector(TDSearchComponentFactory.SELECTORS.searchOverlay);
            this.mountSearchOverlay();
            this.refs.searchInput.addEventListener('input', this.syncTdInlineQueryState, { signal });
            if (this.isHeaderSearch) {
              this.searchOverlay?.addEventListener('click', this.handleSearchOverlayClick, { signal });
            }
            this.addEventListener('focusin', this.syncTdInlineDropdownAriaExpanded, { signal });
            this.addEventListener('focusout', this.scheduleSyncTdInlineDropdownAriaExpanded, { signal });
            this.syncTdInlineQueryState();
            this.syncTdInlineDropdownAriaExpanded();
            this.tdObservePredictiveResultsForAriaSync();
          }
        }

        disconnectedCallback() {
          if (this.searchOverlay?.parentElement === document.body) {
            this.searchOverlay.remove();
          }
          this.tdResultsObserver?.disconnect();
          this.tdResultsObserver = null;
          this.tdActiveSearchRequest?.abort();
          this.tdActiveSearchRequest = null;
          if (this.tdSearchDebounceTimer) {
            clearTimeout(this.tdSearchDebounceTimer);
            this.tdSearchDebounceTimer = null;
          }
          this.tdSearchController?.abort();
          this.tdSearchController = null;
          super.disconnectedCallback();
        }

        syncTdInlineQueryState = () => {
          if (this.dialog) return;
          this.dataset.tdHasQuery = this.refs.searchInput.value.trim().length > 0 ? 'true' : 'false';
          this.syncTdInlineDropdownAriaExpanded();
        };

        /**
         * Inline header search: keep listbox aria-expanded aligned with focus and with morphed markup (vendor empty section uses true).
         */
        syncTdInlineDropdownAriaExpanded = () => {
          if (this.dialog) return;
          const dropdown = this.querySelector('#predictive-search-results');
          const input = this.refs.searchInput;
          const hasQuery = this.dataset.tdHasQuery === 'true';
          const hasResults =
            dropdown instanceof HTMLElement &&
            dropdown.querySelector(
              '[data-search-results], [data-single-result-url], .predictive-search-results__no-results'
            ) !== null;
          const expanded = hasQuery && this.matches(':focus-within') && hasResults ? 'true' : 'false';
          if (dropdown instanceof HTMLElement && dropdown.getAttribute('aria-expanded') !== expanded) {
            dropdown.setAttribute('aria-expanded', expanded);
          }
          if (input && input.getAttribute('aria-expanded') !== expanded) {
            input.setAttribute('aria-expanded', expanded);
          }
          if (this.searchOverlay) {
            this.searchOverlay.dataset.tdOpen = expanded === 'true' ? 'true' : 'false';
          }
        };

        scheduleSyncTdInlineDropdownAriaExpanded = () => {
          requestAnimationFrame(() => this.syncTdInlineDropdownAriaExpanded());
        };

        tdObservePredictiveResultsForAriaSync() {
          const root = this.refs.predictiveSearchResults;
          if (!(root instanceof HTMLElement)) return;
          this.tdResultsObserver?.disconnect();
          this.tdResultsObserver = new MutationObserver(() => {
            this.syncTdInlineDropdownAriaExpanded();
          });
          this.tdResultsObserver.observe(root, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['aria-expanded'],
          });
        }

        get searchFilter() {
          const searchFilter = this.querySelector(TDSearchComponentFactory.SELECTORS.searchFilter);
          return searchFilter instanceof HTMLSelectElement ? searchFilter : null;
        }

        get searchOverlay() {
          const searchOverlay = this.tdSearchOverlay || this.querySelector(TDSearchComponentFactory.SELECTORS.searchOverlay);
          return searchOverlay instanceof HTMLElement ? searchOverlay : null;
        }

        mountSearchOverlay() {
          if (!this.isHeaderSearch || !this.searchOverlay) return;
          if (this.searchOverlay.parentElement !== document.body) {
            document.body.appendChild(this.searchOverlay);
          }
        }

        get searchFilterValue() {
          return this.searchFilter?.value.trim() || '';
        }

        get isHeaderSearch() {
          return this.closest('.td-site-header') !== null;
        }

        get isPredictiveSearchEnabled() {
          return this.dataset.tdPredictiveSearchEnabled !== 'false';
        }

        get isFilterModeEnabled() {
          return this.dataset.tdSearchFilterMode === TDSearchComponentFactory.FILTER_MODE;
        }

        splitSearchTerm(searchTerm) {
          const delimiter = ' AND ';
          const delimiterIndex = searchTerm.indexOf(delimiter);

          if (delimiterIndex <= 0) {
            return ['', searchTerm];
          }

          const appliedFilter = searchTerm.slice(0, delimiterIndex).trim();
          const normalizedSearchTerm = searchTerm.slice(delimiterIndex + delimiter.length).trim();

          if (!appliedFilter.startsWith('product_type:') || !normalizedSearchTerm.length) {
            return ['', searchTerm];
          }

          return [appliedFilter, normalizedSearchTerm];
        }

        syncSearchFilterFromInputValue() {
          if (!this.isFilterModeEnabled || !this.searchFilter) return;

          const searchTerm = this.refs.searchInput.value.trim();
          if (!searchTerm.length) return;

          const [appliedFilter, normalizedSearchTerm] = this.splitSearchTerm(searchTerm);
          if (!appliedFilter.length) return;

          const matchingOption = Array.from(this.searchFilter.options).find((option) => option.value === appliedFilter);
          if (!matchingOption) return;

          this.searchFilter.value = appliedFilter;
          this.refs.searchInput.value = normalizedSearchTerm;
        }

        getSearchTerm(searchTerm) {
          const normalizedSearchTerm = searchTerm.trim();
          if (!normalizedSearchTerm.length) return '';
          if (!this.isFilterModeEnabled || !this.searchFilterValue.length) return normalizedSearchTerm;
          return `${this.searchFilterValue} AND ${normalizedSearchTerm}`;
        }

        buildSearchUrl(searchTerm, baseUrl = Theme.routes.search_url) {
          const searchUrl = new URL(baseUrl, location.origin);
          const formData = new FormData(this.refs.form);
          searchUrl.searchParams.set('q', searchTerm);
          for (const [key, value] of formData.entries()) {
            if (key === 'q') continue;
            if (typeof value !== 'string' || !value.length) continue;
            searchUrl.searchParams.set(key, value);
          }

          return searchUrl;
        }

        async fetchPredictiveSearchResults(searchTerm) {
          if (!(this.refs.predictiveSearchResults instanceof HTMLElement) || !this.dataset.sectionId) return;

          this.tdActiveSearchRequest?.abort();
          const abortController = new AbortController();
          this.tdActiveSearchRequest = abortController;

          const searchUrl = this.buildSearchUrl(searchTerm, Theme.routes.predictive_search_url);
          searchUrl.searchParams.set('resources[limit_scope]', 'each');
          searchUrl.searchParams.set('section_id', this.dataset.sectionId);

          try {
            const response = await fetch(searchUrl, { signal: abortController.signal });
            const markup = await response.text();
            if (abortController.signal.aborted) return;

            const parsedMarkup = new DOMParser().parseFromString(markup, 'text/html');
            const resultsMarkup = parsedMarkup.getElementById('predictive-search-results');
            if (!(resultsMarkup instanceof HTMLElement)) return;

            this.refs.predictiveSearchResults.replaceChildren(resultsMarkup);
            this.tdResetScrollPositions();
            this.syncTdInlineDropdownAriaExpanded();
          } catch (error) {
            if (abortController.signal.aborted) return;
            throw error;
          }
        }

        tdResetScrollPositions() {
          requestAnimationFrame(() => {
            this.refs.predictiveSearchResults.querySelector('.predictive-search-results__inner')?.scrollTo(0, 0);
            this.querySelector('.predictive-search-form__content')?.scrollTo(0, 0);
          });
        }

        search = (event) => {
          if (!this.isPredictiveSearchEnabled || !event.inputType) return;

          if (this.tdSearchDebounceTimer) {
            clearTimeout(this.tdSearchDebounceTimer);
          }

          this.tdSearchDebounceTimer = window.setTimeout(() => {
            this.tdSearchDebounceTimer = null;
          const searchTerm = this.getSearchTerm(this.refs.searchInput.value);
          if (!searchTerm.length) {
            this.resetSearch();
            return;
          }

          this.refs.resetButton.hidden = false;
          this.fetchPredictiveSearchResults(searchTerm);
          }, 200);
        };

        handleSearchFilterChange = () => {
          if (!this.isFilterModeEnabled) return;
          if (!this.refs.searchInput.value.trim().length) return;
          this.search({ inputType: 'insertText' });
        };

        handleSearchOverlayClick = () => {
          this.resetSearch(false);
          this.refs.searchInput.blur();
        };

        handleFilteredSubmit = (event) => {
          const searchTerm = this.getSearchTerm(this.refs.searchInput.value);
          if (!searchTerm.length) return;

          event.preventDefault();
          window.location.href = this.buildSearchUrl(searchTerm).toString();
        };

        onSearchKeyDown = (event) => {
          if (event.key !== 'Enter') {
            super.onSearchKeyDown(event);
            return;
          }

          const selectedResult = this.querySelector('[aria-selected="true"]');
          const singleResultContainer = this.refs.predictiveSearchResults.querySelector('[data-single-result-url]');
          if (selectedResult || singleResultContainer instanceof HTMLElement) {
            super.onSearchKeyDown(event);
            return;
          }

          const searchTerm = this.getSearchTerm(this.refs.searchInput.value);
          if (!searchTerm.length) return;

          event.preventDefault();
          window.location.href = this.buildSearchUrl(searchTerm).toString();
        };
      }

      customElements.define('td-search-component', TDSearchComponent);
    }
  }

  if (customElements.get('predictive-search-component')) {
    TDSearchComponentFactory.register();
  } else {
    customElements.whenDefined('predictive-search-component').then(() => {
      TDSearchComponentFactory.register();
    });
  }
}
  } catch(e) { console.error(e); }
})();

})();
